import { render, staticRenderFns } from "./ContaContabil.vue?vue&type=template&id=68bd2260&"
import script from "./ContaContabil.vue?vue&type=script&lang=js&"
export * from "./ContaContabil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports